import React from 'react';
import styled from 'styled-components';
import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import {
  CpBody01Secondary,
  CpHeading04Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import {
  CTALeftAlignedButtonWrapper,
  CpCtaSectionWrapper,
  CtaButton,
} from './cp-cta-left-aligned';
import { CpCtaSectionVariantWidgetProps } from './types';

export const CpCTAStretchedWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow-y: hidden;
  gap: var(--cp-spacing-10);

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const CpCTAStretchedContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-07);
  width: 70%;

  @media (max-width: 480px) {
    width: 90%;
  }
`;

export const Heading = styled(CpHeading04Primary)`
  text-align: left;
  @media (max-width: 480px) {
    text-align: center;
  }
`;
export const Description = styled(CpBody01Secondary)`
  text-align: left;
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const CpCTAStretched: React.FC<CpCtaSectionVariantWidgetProps> = ({
  disabled,
  data,
  widget,
}) => {
  const background = useGetBackground(widget);

  return (
    <CpCtaSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={background}
    >
      <CpCTAStretchedWrapper>
        <CpCTAStretchedContentWrapper>
          <Heading autoAdjustColor data-cy="cp.cta.stretched.title">
            {data?.title}
          </Heading>
          <Description autoAdjustColor data-cy="cp.cta.stretched.description">
            {data?.description}
          </Description>
        </CpCTAStretchedContentWrapper>

        <CTALeftAlignedButtonWrapper>
          <CtaButton
            data-cy="cp.cta.stretched.primaryButton"
            cpType={CustomerPortalButtonType.Primary}
            onClick={() => window.open(data?.primaryButtonLink)}
          >
            {data?.primaryButtonText}
          </CtaButton>
          <CtaButton
            data-cy="cp.cta.stretched.secondaryButton"
            cpType={CustomerPortalButtonType.Secondary}
            onClick={() => window.open(data?.secondaryButtonLink)}
          >
            {data?.secondaryButtonText}
          </CtaButton>
        </CTALeftAlignedButtonWrapper>
      </CpCTAStretchedWrapper>
    </CpCtaSectionWrapper>
  );
};
